"use strict";
/*@__PURE__*/ Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".content-container[_ngcontent-%COMP%]{border-top:1px solid #d3d3d3;padding:34px 25px;position:relative;z-index:1}.content-container[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(:last-child){margin-bottom:30px}.toggle[_ngcontent-%COMP%]{text-decoration:none;text-transform:uppercase;color:#007ab3;font-size:14px;font-weight:600;letter-spacing:1px;cursor:pointer}.toggle[_ngcontent-%COMP%]:hover{color:#008ed6}"];
exports.styles = styles;

